import React from 'react';

import MapControlsZoomMoreIcon from '../Map/MapControls/MapControlsZoom/MapControlsZoomMoreIcon';
import MapControlsZoomLessIcon from '../Map/MapControls/MapControlsZoom/MapControlsZoomLessIcon';
import MapControlsZoomResetIcon from '../Map/MapControls/MapControlsZoom/MapControlsZoomResetIcon';
import HybridIcon from '../Map/MapControls/MapControlsMapTypeToggle/HybridIcon';
import POIIcon from '../Map/MapControls/MapControlsPOIToggle/POIIcon';
import { ReactComponent as HideMarkersIcon } from '../Map/MapControls/MapControlsMarkersToggle/HideMarkersIcon.svg';

const SiteSeeControlsGuide = () => (
  <ul className="siteSeeGuide__list">
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><MapControlsZoomMoreIcon /></span>
      Zoom in and reveal community residences and amenities
    </li>
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><MapControlsZoomLessIcon /></span>
      Zoom out and reveal community surroundings
    </li>
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><MapControlsZoomResetIcon /></span>
      Recenter community and fit to screen
    </li>
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><HybridIcon /></span>
      Show/hide satellite view of community
    </li>
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><POIIcon /></span>
      Show/hide points of interest near commmunity
    </li>
    <li>
      <span className="siteSeeGuide__icon siteSeeGuide__icon--left"><HideMarkersIcon /></span>
      Show/hide community amenity markers
    </li>
  </ul>
);

export default SiteSeeControlsGuide;
